// extracted by mini-css-extract-plugin
export default {"container":"SupportFaq_container__SNts3"};